module.exports = Function.call.bind(Object.prototype.hasOwnProperty);



/*****************
 ** WEBPACK FOOTER
 ** /~/prop-types/lib/has.js
 ** module id = 630
 ** module chunks = 0 1 2 4 5 6 7 8
 **/